module.exports = __webpack_public_path__ + "static/media/P4trans3.78c261f5.png";